import * as z from "zod/v4";

export const invalidateCustomerDiscountCodes = {
  name: "invalidateCustomerDiscountCodes" as const,
  input: z.object({ customerId: z.string() }),
  output: z.object({ success: z.boolean(), message: z.string() }),
};
